import { Outlet, useLocation } from 'react-router-dom';
import AdminSidebar from 'src/components/admin/Sidebar';
import UserNavbar from 'src/components/ui/UserNavbar';
import { usePageHeaderStore } from 'src/store/pageHeaderStore';

const AdminPageLayout = () => {
  const { title, description, actions } = usePageHeaderStore();
  const { pathname } = useLocation();
  const isCurriculumCatalog = pathname.startsWith('/admin/curriculum');

  return (
    <div className="app-layout bg-gray-50">
      <div className="sidebar sticky top-0 h-screen">
        <AdminSidebar />
      </div>
      <div className="content-area min-w-0">
        <UserNavbar
          title={title}
          description={description}
          isAdmin={true}
          isAdminPage={true}
          actions={actions}
          className="px-0 py-0 border-0"
        />

        <main
          className={`min-w-0 flex-grow overflow-y-auto ${
            isCurriculumCatalog ? 'px-2 py-3 sm:px-3' : 'px-6 py-6'
          }`}
        >
          <div className={isCurriculumCatalog ? 'w-full' : 'mx-auto max-w-7xl'}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminPageLayout;
